'use client';

import { VehicleInstructionReadSection } from './vehicle-instruction/instruction-read-section';
import { VehicleInstructionEditSection } from './vehicle-instruction/instruction-edit-section';
import type { VehicleInstructionSectionProps } from './vehicle-instruction/constants';

export type { VehicleInstructionSectionProps };

export function VehicleInstructionSection(
  props: VehicleInstructionSectionProps
) {
  if (props.mode === 'read') {
    return <VehicleInstructionReadSection {...props} />;
  }

  return <VehicleInstructionEditSection {...props} />;
}
